/* =============================================================================
   ZEPHIR — filtros de la PLP y buscador: mejoras de uso
   =============================================================================
   LEER `assets/zephir-filtros.css` PRIMERO: ahi esta explicado que la coleccion
   tiene DOS juegos de filtros y por que la primera version de este archivo
   optimizo el que nadie ve.

   DESDE EL 2026-09-07 LOS CHIPS VAN ESCONDIDOS EN ESCRITORIO y manda un solo
   boton "+ FILTRAR", por la referencia de SKIMS que pidio el cliente. La regla
   esta en assets/plp-editorial.css. Todo lo de los chips se conserva aqui
   porque siguen existiendo en el DOM y porque el buscador los monta.

   !!! OJO CON LAS BARRAS INVERTIDAS DE LAS EXPRESIONES REGULARES !!!
   Este archivo se sube por la API con un bloque de texto que NO procesa
   escapes: una barra doble se queda EN DOBLE en el archivo. El 2026-09-07 eso
   dejo la clase de caracteres del recuento con barra, d, punto y coma -- y el
   boton del cajon decia "Ver d productos" en vez de "Ver 24 productos". Los
   `/\s+/g` de limpiar espacios eran no-ops silenciosos desde antes. AQUI VAN
   SIEMPRE BARRAS SIMPLES.

   Lo que hace este JS, sobre lo que el tema ya pinta:
     0. HACE QUE LOS CHIPS ABRAN EL CAJON. No lo hacian: en escritorio no se
        podia filtrar. (El boton FILTRAR del tema SI abre por su cuenta:
        comprobado con clic real. No hace falta engancharlo.)
     1. ESCONDE EL CHIP DE LAS FACETAS DE UN SOLO VALOR.
     1b. CONSTRUYE LA BARRA DE CHIPS EN EL BUSCADOR.
     2. NOMBRE ACCESIBLE A LAS PASTILLAS DE QUITAR FILTRO (el aspa del tema son
        pseudoelementos y no llegan al lector de pantalla).
     3. NOMBRE AL "LIMPIAR TODO" DEL TEMA.
     4. ANUNCIA EL RECUENTO como frase completa (`role=status`).
     5. SEMANTICA DE BOTON A LOS TITULOS DEL CAJON (son `<h5 onclick>`).
     6. EL BUSCADOR EN `type=search`, que en movil trae la tecla "buscar".
     7. NOMBRA los botones y enlaces del tema que solo llevan un icono.
     8. EL CAJON, COMO EN LA REFERENCIA: estado de los filtros en la cabecera y
        boton fijo abajo con el recuento ("Ver 3 productos").

   DOS COSAS QUE SE PROBARON Y SE QUITARON — NO REPONERLAS SIN MEDIR
   a) UNA FILA PROPIA DE FICHAS DE FILTRO ACTIVO Y UN "LIMPIAR TODO" PROPIO.
      El tema ya trae `.t4s-active-filters` con todo eso.
   b) ABRIR TALLA Y COLOR POR DEFECTO. Los paneles de faceta son
      `position:absolute` y el cajon los superpone: al forzar dos abiertos, el
      panel de Talla TAPABA el titulo de Color.
   ========================================================================== */
(function () {
  'use strict';

  function sinTildes(s) {
    return String(s || '').toLowerCase()
      .replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i')
      .replace(/ó/g, 'o').replace(/ú/g, 'u').replace(/ñ/g, 'n');
  }

  function limpio(t) {
    return String(t || '').replace(/\s+/g, ' ').trim();
  }

  /* nombre de faceta sin el contador que el tema anade: "Color (1)" -> "color" */
  function nombreFaceta(t) {
    return sinTildes(t).replace(/\s*\(\d+\)\s*$/, '').replace(/\s+/g, ' ').trim();
  }

  function nombreVisible(t) {
    return limpio(String(t || '').replace(/\s*\(\d+\)\s*$/, ''));
  }

  /* --- 0. EL CAJON DE FILTROS: ABRIRLO DE VERDAD ------------------------
     ESTO ARREGLA EL FALLO MAS GRAVE DE LA PLP: LOS CHIPS NO ABRIAN NADA.
     Comprobado con clic real en /collections/buzos: el cajon se quedaba en
     `x = -354` (fuera de pantalla).

     La causa: el tema engancha sus `[data-drawer-options]` AL ARRANCAR y no
     coge estos botones. NO sirve: `.click()` sintetico, pointerdown/mouseup,
     `T4SThemeSP.Drawer.opend(...)` (pide un objeto tipo jQuery que el tema no
     expone) ni `T4SThemeSP.Drawer.init()`.

     Lo que SI sirve es reproducir el estado que deja el tema al abrir un cajon
     que si funciona (se observo el del carrito con un clic real):

         cajon  aria-hidden="false"     (cerrado es "true")
         body   .t4s-lock-scroll .is--opend-drawer
         velo   .t4s-close-overlay.is--visible */

  var CAJON = '#t4s-filter-hidden';
  var ultimoDisparador = null;
  /* HASTA CUANDO SE DEFIENDE LA APERTURA. Medido: EL PRIMER CLIC TRAS CARGAR NO
     ABRIA y el segundo si. El tema inicializa el cajon en la primera
     interaccion y en ese repintado devuelve `aria-hidden` a "true". Durante
     1,2 s se vuelve a poner si alguien lo quita. Ventana corta a proposito. */
  var defenderHasta = 0;

  function cajon() { return document.querySelector(CAJON); }

  function hayCajonAbierto() {
    return !!document.querySelector('.t4s-drawer[aria-hidden="false"]');
  }

  function limpiarCuerpo() {
    if (!hayCajonAbierto()) {
      document.body.classList.remove('t4s-lock-scroll', 'is--opend-drawer');
      var velo = document.querySelector('.t4s-close-overlay');
      if (velo) velo.classList.remove('is--visible');
    }
  }

  function ponerAbierto(c) {
    c.setAttribute('aria-hidden', 'false');
    document.body.classList.add('t4s-lock-scroll', 'is--opend-drawer');
    var velo = document.querySelector('.t4s-close-overlay');
    if (velo) velo.classList.add('is--visible');
  }

  function reafirmar() {
    if (Date.now() > defenderHasta) return;
    var c = cajon();
    if (c && c.getAttribute('aria-hidden') !== 'false') ponerAbierto(c);
  }

  function abrirCajon(indice, disparador) {
    var c = cajon();
    if (!c) return false;

    ultimoDisparador = disparador || null;
    defenderHasta = Date.now() + 1200;
    ponerAbierto(c);

    /* Reintentos escalonados: el repintado del tema puede llegar en cualquier
       momento de ese primer segundo, y no avisa. */
    [60, 180, 400, 700, 1100].forEach(function (ms) { setTimeout(reafirmar, ms); });

    if (indice != null) {
      var bloques = c.querySelectorAll('.custom-filter-block');
      var b = bloques[indice];
      if (b) {
        var cuerpo = b.querySelector('.t4s-facet, .t4s-facet-content');
        var titulo = b.querySelector('h5.t4s-facet-title');
        if (cuerpo && titulo && getComputedStyle(cuerpo).display === 'none') titulo.click();
      }
    }

    /* el foco entra en el cajon: si no, quien navega con teclado sigue en la
       parrilla de detras y no llega a los filtros que acaba de abrir. */
    var foco = c.querySelector('h5.t4s-facet-title, button, a, input');
    if (foco) { try { foco.focus({ preventScroll: true }); } catch (e) { foco.focus(); } }
    return true;
  }

  function cerrarCajon() {
    var c = cajon();
    defenderHasta = 0;                 // deja de defenderse: cierra quien manda
    if (!c || c.getAttribute('aria-hidden') === 'true') { limpiarCuerpo(); return; }
    c.setAttribute('aria-hidden', 'true');
    limpiarCuerpo();
    if (ultimoDisparador && document.contains(ultimoDisparador)) {
      try { ultimoDisparador.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function engancharCajon() {
    if (document.documentElement.hasAttribute('data-zph-cajon')) return;
    document.documentElement.setAttribute('data-zph-cajon', '1');

    document.addEventListener('click', function (ev) {
      var chip = ev.target.closest && ev.target.closest('.t4s-filter-chip');
      if (!chip) return;
      ev.preventDefault();
      var i = chip.getAttribute('data-zf-open-filter');
      abrirCajon(i == null ? null : parseInt(i, 10), chip);
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') cerrarCajon();
    });

    var c = cajon();
    if (c) {
      new MutationObserver(function () {
        if (c.getAttribute('aria-hidden') !== 'true') return;
        if (Date.now() <= defenderHasta) reafirmar();   // fue el repintado del tema
        else limpiarCuerpo();                           // fue un cierre de verdad
      }).observe(c, { attributes: true, attributeFilter: ['aria-hidden'], childList: true });
    }

    /* CERRAR: el velo del tema pone `aria-hidden="true"` pero NO limpia el
       `t4s-lock-scroll` del body -- la pagina se quedaba sin scroll. Y el aspa
       del cajon esta dentro de un nodo que el tema repinta. Tres vias, por
       delegacion. */
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t.closest) return;
      if (t.closest('.t4s-close-overlay')) { cerrarCajon(); return; }
      var dentro = t.closest(CAJON);
      if (dentro && t.closest('[data-drawer-close], .t4s-drawer__close, [class*="close"]')) cerrarCajon();
    });
  }

  /* --- 1. los chips: fuera los que no pueden estrechar nada -------------- */

  function prepararChips() {
    var chips = document.querySelectorAll('.t4s-filter-chip');
    if (!chips.length) return;

    var valores = {};
    document.querySelectorAll('.custom-filter-block').forEach(function (b) {
      var t = b.querySelector('h5.t4s-facet-title');
      if (!t) return;
      valores[nombreFaceta(t.textContent)] = {
        n: b.querySelectorAll('.t4s-filter__values li').length,
        puesto: !!b.querySelector('.t4s-filter__values li.is--selected')
      };
    });

    chips.forEach(function (c) {
      c.setAttribute('aria-haspopup', 'dialog');
      var f = valores[nombreFaceta(c.textContent)];
      /* Si la faceta tiene UN valor y no esta puesto, el chip no sirve. Si esta
         puesto, se queda: es la via para quitarlo desde el cajon. Si la faceta
         no aparece en el cajon (Precio), no se toca. */
      if (f && f.n === 1 && !f.puesto) {
        c.style.display = 'none';
      } else if (c.style.display === 'none') {
        c.style.display = '';
      }
    });
  }

  /* --- 1b. la barra de chips en el BUSCADOR ------------------------------
     La pinta `sections/main-collection.liquid`, asi que el buscador -- que usa
     `main-search.liquid` -- se quedaba sin ella. Se construye desde el cajon.
     Quien los hace funcionar es `engancharCajon()`, no el tema. */

  function chipsEnBusqueda() {
    if (document.querySelector('.t4s-filter-chips')) return;

    var hueco = document.querySelector('.t4s-btn-filter-wrapper');
    var bloques = document.querySelectorAll('.custom-filter-block');
    if (!hueco || !bloques.length) return;      // sin cajon todavia: se reintenta

    var barra = document.createElement('div');
    barra.className = 't4s-filter-chips zph-chips-js';

    bloques.forEach(function (b, i) {
      var t = b.querySelector('h5.t4s-facet-title');
      if (!t) return;
      var puestos = b.querySelectorAll('.t4s-filter__values li.is--selected').length;

      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 't4s-filter-chip' + (puestos ? ' is--active' : '');
      chip.setAttribute('data-btn-as-a', '');
      chip.setAttribute('data-drawer-options', '{ "id":"#t4s-filter-hidden" }');
      chip.setAttribute('data-zf-open-filter', String(i));
      chip.setAttribute('aria-haspopup', 'dialog');
      chip.textContent = nombreVisible(t.textContent) + (puestos ? ' (' + puestos + ')' : '');
      barra.appendChild(chip);
    });

    if (!barra.children.length) return;
    hueco.insertBefore(barra, hueco.firstChild);
  }

  /* --- 2, 3 y 4. la fila de filtros activos del tema --------------------- */

  function mejorarFilaActiva() {
    var fila = document.querySelector('.t4s-active-filters');
    if (!fila) return;

    [].slice.call(fila.querySelectorAll('.t4s-active-filters__remove-filter')).forEach(function (a) {
      var etiqueta = limpio(a.textContent);
      /* El aspa son los `::before` y `::after` del tema, y un pseudoelemento no
         llega al lector de pantalla: sin esto el enlace se anuncia como "Negro"
         y parece que LLEVA a los productos negros, cuando hace lo contrario. */
      if (etiqueta) a.setAttribute('aria-label', 'Quitar el filtro ' + etiqueta);
    });

    var limpiarTodo = fila.querySelector('.t4s-active-filters__clear');
    if (limpiarTodo) limpiarTodo.setAttribute('aria-label', 'Quitar todos los filtros');

    /* EL RECUENTO, COMO FRASE. Un `role=status` que solo diga "2" no informa; y
       el tema lo deja como texto muerto, sin anunciar nada al filtrar por AJAX.
       No se reescribe el texto: ya dice "3 Productos encontrados". */
    var cuenta = fila.querySelector('.t4s-active-filters__count');
    if (cuenta && cuenta.getAttribute('role') !== 'status') {
      cuenta.setAttribute('role', 'status');
      cuenta.setAttribute('aria-atomic', 'true');
    }
  }

  /* --- 5. los titulos del cajon: boton y teclado ------------------------- */

  function prepararFacetas() {
    document.querySelectorAll('.custom-filter-block').forEach(function (b) {
      var titulo = b.querySelector('h5.t4s-facet-title');
      var cuerpo = b.querySelector('.t4s-facet, .t4s-facet-content');
      if (!titulo || !cuerpo || titulo.hasAttribute('role')) return;

      titulo.setAttribute('role', 'button');
      titulo.setAttribute('tabindex', '0');
      if (!cuerpo.id) cuerpo.id = 'zph-facet-' + Math.random().toString(36).slice(2, 8);
      titulo.setAttribute('aria-controls', cuerpo.id);
      titulo.setAttribute('aria-expanded',
        getComputedStyle(cuerpo).display !== 'none' ? 'true' : 'false');

      titulo.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
          ev.preventDefault();
          titulo.click();          // el onclick del tema es quien abre y cierra
        }
      });
      /* aria-expanded al dia. Se lee DESPUES del clic porque la animacion del
         tema tarda en dejar el display definitivo. */
      titulo.addEventListener('click', function () {
        setTimeout(function () {
          titulo.setAttribute('aria-expanded',
            getComputedStyle(cuerpo).display !== 'none' ? 'true' : 'false');
        }, 320);
      });
    });
  }

  /* --- 6. el buscador: teclado correcto en movil ------------------------- */

  function prepararBuscador() {
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      if (i.type !== 'search') i.type = 'search';
      i.setAttribute('enterkeyhint', 'search');
      i.setAttribute('autocapitalize', 'off');
      i.setAttribute('autocorrect', 'off');
      i.setAttribute('spellcheck', 'false');
      if (!i.getAttribute('aria-label')) {
        i.setAttribute('aria-label', i.getAttribute('placeholder') || 'Buscar productos');
      }
    });
  }

  /* --- 7. nombres accesibles a controles del tema sin texto --------------
     En la ficha habia 5 botones sin nombre y en la portada 3 enlaces (menu
     movil, lupa y cuenta, de header-inline.liquid, 38 KB y no escribible). El
     nombre se deduce de lo que hace cada uno. El del carrito se recalcula en
     cada pasada porque su texto es solo "0 / $0".

     Y EL MEGA-MENU (88 KB): cada azulejo lleva un `.t4s-full-width-link` VACIO
     encima de la foto y al lado un `a.t4s-cat-title` con el mismo destino. Se
     saca el vacio del arbol de accesibilidad. Los banners sin alt se nombran
     con el texto de OTRO enlace al mismo destino; si no existe, se dejan antes
     que inventar un nombre. */

  function nombresAccesibles() {
    document.querySelectorAll('button.t4s-quantity-selector.is--minus:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Restar una unidad');
    });
    document.querySelectorAll('button.t4s-quantity-selector.is--plus:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Sumar una unidad');
    });
    document.querySelectorAll('.t4s-mini-search__submit:not([aria-label]), button[data-submit-search]:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Buscar');
    });

    document.querySelectorAll('.t4s-push-menu-btn:not([aria-label])').forEach(function (a) {
      a.setAttribute('aria-label', 'Abrir el menú');
      a.setAttribute('aria-haspopup', 'dialog');
    });
    document.querySelectorAll('.t4s-site-nav__icons a, .t4s-site-nav__icon a').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var opts = a.getAttribute('data-drawer-options') || '';
      var texto = limpio(a.textContent);

      if (href.indexOf('/cart') === 0 || opts.indexOf('cart') > -1) {
        var n = parseInt(texto, 10);
        a.setAttribute('aria-label', isNaN(n) ? 'Carrito' :
          'Carrito, ' + n + (n === 1 ? ' artículo' : ' artículos'));
        return;
      }
      if (a.hasAttribute('aria-label')) return;
      var nombre = '';
      if (href.indexOf('/search') === 0 && href.indexOf('wishlist') === -1 || opts.indexOf('search') > -1) nombre = 'Buscar';
      else if (href.indexOf('/account') === 0) nombre = 'Mi cuenta';
      else if (href.indexOf('wishlist') > -1 || opts.indexOf('wishlist') > -1) {
        var w = parseInt(texto, 10);
        nombre = isNaN(w) ? 'Lista de deseos' : 'Lista de deseos, ' + w + (w === 1 ? ' artículo' : ' artículos');
      }
      else if (href.indexOf('compare') > -1 || opts.indexOf('compare') > -1) nombre = 'Comparar productos';
      if (!nombre && texto) return;          // ya tiene texto propio
      if (nombre) {
        a.setAttribute('aria-label', nombre);
        if (opts) a.setAttribute('aria-haspopup', 'dialog');
      }
    });

    function conNombre(a) {
      return !!((a.getAttribute('aria-label') || a.textContent || '').trim());
    }
    document.querySelectorAll('a.t4s-full-width-link:not([aria-hidden]):not([aria-label])').forEach(function (a) {
      if (conNombre(a)) return;
      var caja = a.closest('.t4s-cat-content, .t4s-collection-item, .t4s-menu-item, .t4s-product-inner') || a.parentElement;
      var href = a.getAttribute('href');
      var titulado = caja && [].slice.call(caja.querySelectorAll('a[href]')).some(function (o) {
        return o !== a && o.getAttribute('href') === href && (o.textContent || '').trim();
      });
      if (titulado) {
        a.setAttribute('aria-hidden', 'true');
        a.setAttribute('tabindex', '-1');
      }
    });
    document.querySelectorAll('.type_mn_banner a[href]:not([aria-label])').forEach(function (a) {
      if (conNombre(a)) return;
      var img = a.querySelector('img');
      if (img && (img.getAttribute('alt') || '').trim()) return;   // la imagen ya lo nombra
      var ruta;
      try { ruta = new URL(a.getAttribute('href'), location.href).pathname; } catch (e) { return; }
      var otro = [].slice.call(document.querySelectorAll('a[href]')).find(function (o) {
        if (o === a || o.closest('.type_mn_banner')) return false;
        try { return new URL(o.getAttribute('href'), location.href).pathname === ruta && (o.textContent || '').trim(); }
        catch (e) { return false; }
      });
      if (otro) a.setAttribute('aria-label', limpio(otro.textContent));
    });
  }

  /* --- 8. EL CAJON COMO EN LA REFERENCIA (SKIMS) -------------------------
     a) EL ESTADO EN LA CABECERA. SKIMS pone "No filters selected" arriba. Aqui
        se cuentan las pastillas de filtro activo del tema, que es el dato
        fiable y ya esta en la pagina.

     b) UN BOTON FIJO ABAJO CON EL RECUENTO. Hace mas falta aqui que alli: el
        tema aplica cada faceta por AJAX y recarga la parrilla POR DETRAS del
        cajon, asi que quien filtra no ve el resultado hasta que cierra.

     DE DONDE SALE EL NUMERO, Y EN QUE ORDEN — ESTO TIENE TRAMPA
     -----------------------------------------------------------
     Hay DOS recuentos en la pagina y dicen cosas distintas:
         .t4s-active-filters__count  ->  "3 Productos encontrados"  (FILTRADO)
         .t4s-plp-count              ->  "24 productos"             (TOTAL)
     Y `.t4s-plp-count` va ANTES en el documento. Con un selector combinado
     `querySelector('.a, .b')` gana el primero EN ORDEN DEL DOCUMENTO, no en
     orden del selector: el boton decia "Ver 24 productos" con un filtro puesto
     que dejaba 3. Se piden por separado y con prioridad explicita.

     Y NO se cuentan tarjetas: desde la "tarjeta por color" un producto pinta
     una tarjeta por cada color con foto (medido: 3 productos -> 4 tarjetas).
     Si no hay ningun recuento, el boton dice "Ver productos": mejor sin numero
     que con uno inventado. */

  function textoRecuento() {
    var n = document.querySelector('.t4s-active-filters__count') ||
            document.querySelector('.t4s-plp-count');
    var m = n ? limpio(n.textContent).match(/[0-9][0-9.,]*/) : null;
    return m ? m[0] : '';
  }

  function estadoCabecera(c) {
    var cab = c.querySelector('.t4s-drawer__header');
    if (!cab) return;
    var el = cab.querySelector('.zph-filtro-estado');
    if (!el) {
      el = document.createElement('span');
      el.className = 'zph-filtro-estado';
      cab.appendChild(el);
    }
    var n = document.querySelectorAll('.t4s-active-filters__remove-filter').length;
    var txt = n === 0 ? 'Sin filtros aplicados'
            : n === 1 ? '1 filtro aplicado'
                      : n + ' filtros aplicados';
    if (el.textContent !== txt) el.textContent = txt;
  }

  function botonAplicar(c) {
    var b = c.querySelector('.zph-filtro-aplicar');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'zph-filtro-aplicar';
      b.addEventListener('click', function () { cerrarCajon(); });
      c.appendChild(b);
    }
    var num = textoRecuento();
    var txt = num ? 'Ver ' + num + ' productos' : 'Ver productos';
    if (b.textContent !== txt) b.textContent = txt;
    b.setAttribute('aria-label', txt + ' — cierra los filtros');
  }

  /* --- arranque ---------------------------------------------------------- */

  /* FIRMA PARA NO REALIMENTARSE. `mejorarFilaActiva` toca el DOM y el
     observador de abajo escucha el DOM: sin esto se llamaria a si mismo cada
     250 ms para siempre. */
  var firmaPrevia = null;

  function firma() {
    var act = [].slice.call(document.querySelectorAll('.t4s-active-filters__remove-filter'))
      .map(function (a) { return (a.textContent || '').trim(); }).join('~');
    /* el nº de facetas ENTRA en la firma a proposito: en el buscador el cajon
       llega por AJAX despues de la primera pasada, y ese cambio es justo lo que
       tiene que disparar la construccion de la barra de chips. */
    return document.querySelectorAll('.t4s-filter-chip').length + '/' +
      document.querySelectorAll('.custom-filter-block').length + '#' + act +
      '#' + textoRecuento();
  }

  function iniciar(forzar) {
    /* El buscador va SIEMPRE, fuera de la guarda de firma: vive en un cajon de
       la cabecera que el tema pinta MAS TARDE, y la firma solo vigila filtros.
       Es idempotente. */
    prepararBuscador();
    nombresAccesibles();

    var f = firma();
    if (!forzar && f === firmaPrevia) return;
    firmaPrevia = f;
    engancharCajon();
    prepararChips();
    chipsEnBusqueda();
    mejorarFilaActiva();
    prepararFacetas();

    var c = cajon();
    if (c) { estadoCabecera(c); botonAplicar(c); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(true); });
  } else {
    iniciar(true);
  }

  /* El tema repinta parrilla, chips y fila de activos por AJAX al filtrar, sin
     recargar: sin volver a pasar por aqui se perderian el aria y el rol del
     recuento. Observador debounceado -- sin el, los scripts de terceros lo
     dispararian cientos de veces. */
  var pendiente = null;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = setTimeout(function () { pendiente = null; iniciar(false); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();